import { render, staticRenderFns } from "./InputCom.vue?vue&type=template&id=f036cb76&scoped=true&"
import script from "./InputCom.vue?vue&type=script&lang=js&"
export * from "./InputCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036cb76",
  null
  
)

export default component.exports